import type { GeoJsonObject, LineString, MultiLineString, MultiPolygon, Polygon } from 'geojson';
import L from 'leaflet';
import React from 'react';
import { Icon } from '../../Icon/Icon';

export const isSmallScreen = (): boolean => {
    // 680px is taken from _breakpoints.scss
    return document.body.clientWidth <= 680;
};

export const zoomToMarkerBounds = function (): void {
    let key, bounds;
    const layers = this.map._layers;

    for (key in layers) {
        if (Object.hasOwn(layers, key)) {
            if (layers[key] instanceof L.MarkerClusterGroup) {
                bounds = bounds ? bounds.extend(layers[key].getBounds()) : layers[key].getBounds();
            }
        }
    }
    if (bounds && bounds.isValid()) {
        this.map.fitBounds(bounds, {
            maxZoom: 9,
        });
    }
};

export const calculateDefaultLayers = function (initialDefaultLayers: string[], userLayers?: { [layerId: string]: boolean }): string[] {
    let defaultLayers = [...initialDefaultLayers];
    if (userLayers) {
        Object.entries(userLayers).forEach(([key, value]) => {
            if (value) {
                // eslint-disable-next-line @typescript-eslint/no-unused-expressions
                defaultLayers.indexOf(key) === -1 && defaultLayers.push(key);
            } else {
                defaultLayers = defaultLayers.filter((id) => id !== key);
            }
        });
    }
    return defaultLayers;
};

export const splitMultiPolygon = function (geoJson: GeoJsonObject): Polygon[] {
    if (geoJson.type === 'MultiPolygon') {
        return (geoJson as MultiPolygon).coordinates.map((coordinates) => ({
            type: 'Polygon',
            coordinates,
        }));
    }
    return null;
};

export const splitMultiLineString = function (geoJson: MultiLineString): LineString[] {
    return geoJson.coordinates.map((coordinates) => ({
        type: 'LineString',
        coordinates,
    }));
};

export const createSVGIcon: React.FC<string> = (iconId: string) => <Icon symbol={iconId} />;
